import React from 'react';
import { Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const DateRangePicker = ({
    fromDate,
    toDate,
    onFromChange,
    onToChange,
    disabled = false,
    fromLabel = 'From Date',
    toLabel = 'To Date',
    size = 'medium'
}) => {
    return (
        <Stack direction="row" spacing={2}>
            <DatePicker
                label={fromLabel}
                value={fromDate}
                onChange={onFromChange}
                disabled={disabled}
            />
            <DatePicker
                label={toLabel}
                value={toDate}
                onChange={onToChange}
                disabled={disabled}
            />
        </Stack>
    );
};

export default DateRangePicker;